import { ResponsiveCard } from '../../molecules/card/Card';
import { PageSectionForCards } from '../../molecules/pageSection/PageSection';

export function GhcInformationCard() {
    return (
        <PageSectionForCards chapterTitle="Over het Thuisconsult">
            <ResponsiveCard
                body="Bekijk hoe makkelijk het werkt, ook voor jou."
                cardTitle="Hoe werkt het?"
                lg={12}
                linksText={['Lees verder']}
                linksTo={['/ghc/information']}
            />
        </PageSectionForCards>
    );
}
